"use strict";
/**
 * Copyright © 2019 Johnson & Johnson
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 * http://www.apache.org/licenses/LICENSE-2.0
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GlobalTooltip = exports.ToolbarDivider = exports.FormWrapper = void 0;

var react_1 = __importDefault(require("react"));

var rc_tooltip_1 = __importDefault(require("rc-tooltip"));

var lodash_1 = require("lodash");

var fclasses_1 = require("@bodiless/fclasses");

var core_1 = require("@bodiless/core");

var ui_1 = require("@bodiless/ui");

var ReactTags_1 = __importDefault(require("./ReactTags"));

var Toolbar = lodash_1.flow(fclasses_1.addClasses('bl-flex bl-flex-col bl-w-grid-12 bl-bg-black bl-rounded bl-z-50 bl-px-grid-2 bl-py-2 bl-fixed bl-top-grid-0 bl-left-grid-0 bl-text-white'), fclasses_1.addProps({
  role: 'toolbar',
  'aria-label': 'Global Context Menu Left',
  id: 'global-context-menu'
}))(ui_1.Div);
var ToolbarRight = lodash_1.flow(fclasses_1.addClasses('bl-right-grid-0'), fclasses_1.removeClasses('bl-left-grid-0'), fclasses_1.addProps({
  'aria-label': 'Global Context Menu Right'
}))(Toolbar);
exports.FormWrapper = fclasses_1.addClasses('bl-flex')(ui_1.Div);
exports.ToolbarDivider = fclasses_1.addClasses('bl-bg-grey bl-w-grid-12 bl--ml-grid-2 bl-mb-grid-3 bl-h-px')(ui_1.Hr);

exports.GlobalTooltip = function (props) {
  return react_1.default.createElement(rc_tooltip_1.default, __assign({
    align: {
      offset: [5, 0]
    }
  }, props, {
    placement: "rightTop",
    overlayStyle: {
      position: 'fixed',
      opacity: 1
    },
    getTooltipContainer: function getTooltipContainer() {
      var el = document.getElementById('global-tooltip-container');

      if (!el) {
        el = document.createElement('div');
        el.setAttribute('id', 'global-tooltip-container');
        el.setAttribute('style', 'position: fixed; z-index: 1000;');
        document.body.appendChild(el);
      }

      return el;
    }
  }));
};

var GlobalTooltipRight = lodash_1.flow(fclasses_1.addProps({
  align: {
    offset: [5, 0],
    useCssRight: true
  }
}))(exports.GlobalTooltip);
var ui = {
  ComponentFormTitle: ui_1.ComponentFormTitle,
  ComponentFormLabel: ui_1.ComponentFormLabel,
  ComponentFormDescription: ui_1.ComponentFormDescription,
  ComponentFormText: ui_1.ComponentFormText,
  ComponentFormTextArea: ui_1.ComponentFormTextArea,
  ComponentFormFieldWrapper: ui_1.ComponentFormFieldWrapper,
  ComponentFormFieldTitle: ui_1.ComponentFormFieldTitle,
  ComponentFormCheckBox: ui_1.ComponentFormCheckBox,
  ComponentFormRadio: ui_1.ComponentFormRadio,
  ComponentFormRadioGroup: ui_1.ComponentFormRadioGroup,
  ComponentFormSelect: ui_1.ComponentFormSelect,
  ComponentFormOption: ui_1.ComponentFormOption,
  ComponentFormButton: ui_1.ComponentFormButton,
  ComponentFormCloseButton: ui_1.ComponentFormCloseButton,
  ComponentFormSubmitButton: ui_1.ComponentFormSubmitButton,
  ComponentFormUnwrapButton: ui_1.ComponentFormUnwrapButton,
  ComponentFormError: ui_1.ComponentFormError,
  ComponentFormWarning: ui_1.ComponentFormWarning,
  ComponentFormLink: ui_1.ComponentFormLink,
  ComponentFormList: ui_1.ComponentFormList,
  ComponentFormListItem: ui_1.ComponentFormListItem,
  Icon: ui_1.ToolbarIcon,
  ContextSubMenu: ui_1.ContextSubMenu,
  Toolbar: Toolbar,
  ToolbarButton: ui_1.ToolbarButton,
  HorizontalToolbarButton: ui_1.HorizontalToolbarButton,
  ToolbarButtonLabel: ui_1.ToolbarButtonLabel,
  ToolbarDivider: exports.ToolbarDivider,
  FormWrapper: exports.FormWrapper,
  Tooltip: exports.GlobalTooltip,
  ReactTags: ReactTags_1.default
};

var GlobalContextMenu = function GlobalContextMenu(props) {
  var _a = props.isPositionToggled,
      isPositionToggled = _a === void 0 ? false : _a;

  if (isPositionToggled) {
    var updatedUi = __assign(__assign({}, ui), {
      Toolbar: ToolbarRight,
      Tooltip: GlobalTooltipRight
    });

    return react_1.default.createElement(core_1.ContextMenu, __assign({}, props, {
      ui: updatedUi
    }));
  }

  return react_1.default.createElement(core_1.ContextMenu, __assign({}, props, {
    ui: ui
  }));
};

exports.default = GlobalContextMenu;